import { toast } from 'react-toastify';
import { ToastAsync, ToastSync } from './toast.type';
import { ToastNotification } from './toast-notification/ToastNotification';
import { PromiseToastNotification } from './toast-notification/PromiseToastNotification';
import styles from './toast.module.scss';

export const TOAST_CONTAINER = 'toast';

export const displayToast = (toastProps: ToastSync) => {
  const isPermanent = toastProps.options?.disableTimeout === true;
  toast(({ closeToast }) => <ToastNotification closeToast={closeToast} toast={toastProps} />, {
    toastId: toastProps.toastId,
    autoClose: isPermanent ? false : undefined,
    containerId: TOAST_CONTAINER,
    ...toastProps.toastOverrides
  });
};

export const displayAsyncToast = (toastProps: ToastAsync) => {
  const toastId = toast(
    ({ closeToast }) => (
      <PromiseToastNotification
        status='info'
        closeToast={closeToast}
        toast={toastProps}
        icon={<div className={styles.loader} />}
      />
    ),
    {
      toastId: toastProps.toastId,
      autoClose: false,
      containerId: TOAST_CONTAINER,
      ...toastProps.toastOverrides
    }
  );

  toastProps
    .promise()
    .then(() => {
      toast.dismiss(toastId);
      toast(
        ({ closeToast }) => (
          <PromiseToastNotification status='success' closeToast={closeToast} toast={toastProps} />
        ),
        {
          toastId: `${toastProps.toastId}-success`,
          autoClose: 5000,
          containerId: TOAST_CONTAINER,
          ...toastProps.toastOverrides
        }
      );
    })
    .catch(() => {
      toast.dismiss(toastId);
      toast(
        ({ closeToast }) => (
          <PromiseToastNotification status='error' closeToast={closeToast} toast={toastProps} />
        ),
        {
          toastId: `${toastProps.toastId}-error`,
          autoClose: 5000,
          containerId: TOAST_CONTAINER,
          ...toastProps.toastOverrides
        }
      );
    });

  return toastId;
};

export const closeToast = (toastId: string) => {
  toast.dismiss({ id: toastId, containerId: TOAST_CONTAINER });
};

export const closeAllToasts = () => {
  toast.dismiss({ containerId: TOAST_CONTAINER });
};
